import React, {useMemo, useState} from "react";
import {useStore} from "../../hooks/useStore";
import {generateRandomOrderNumber} from "../../utils/helpers";
import {useTranslation} from "react-i18next";
import Exceljs from "exceljs";
import {message, Table} from "antd";
import {Redirect, useHistory} from "react-router-dom";
export const useCreateDeliveryRequest = ({isFromCustomerTheme}) => {
    const stores = useStore();
    const {t} = useTranslation();
    const history = useHistory();

    //#region state and variables
    const productPrototype = {
        //productName: "",
        productName: "Test Ürün",
        //ingredients: "",
        ingredients: "Test İçerik",
        amount: 1, //default 1
        productDesiAmount: 1, //always 1
        return: false, //always false
        willBeDeleted: false, //always false
        isTrial: false //always false
    };
    const orderPrototype = {
        index: 0, //default 0, increment for each order
        pickupInfoIndex: 1, //always 1
        //receiverName: "",
        receiverName: "",
        receiverAddress: "",
        //receiverAddressDetail: "",
        receiverAddressDetail: "",
        //receiverPhone: "",
        receiverPhone: "",
        //note: "",
        note: "",
        orderNumber: generateRandomOrderNumber(), //create a unique number for each order, six digits
        paymentType: "", //default unspecified
        price: "0", //default 0
        dontRingTheBell: false, //always false
        receiverLocation: undefined, //default 0,0
        products: [productPrototype], //array of productPrototype
        barcodeIsRequired: false, //always false
        source: history.location.pathname === "/create-delivery-request" ? "manuelv2" : "manuelv1"
    };
    const formData = {
        token: "", //selected company's api token
        apiKey: "", //selected company's api key
        data: {
            pickupInfos: [{pickupPointId: "", index: 1}],
            courierType: "motorCourier", //always motorCourier
            deliveryType: "delivery", //always delivery
            orders: [orderPrototype] //array of orderPrototype
        }
    };

    const [fromCustomerTheme] = useState(isFromCustomerTheme);
    const [form, setForm] = useState(formData);
    const [errors, setErrors] = useState({});
    const [selectedCompany, setSelectedCompany] = useState();
    const [selectedSubCompany, setSelectedSubCompany] = useState();
    const [paymentTypes, setPaymentTypes] = useState([]);
    const [paymentTypesLoading, setPaymentTypesLoading] = useState(false);
    //#endregion state and variables

    const handleExcelUpload = async data => {
        try {
            const workbook = new Exceljs.Workbook();
            await workbook.xlsx.load(data);
            const json = JSON.stringify(workbook.model);
            const rows = JSON.parse(json).worksheets[0].rows.filter(
                r => r.cells[0].value != undefined
            );
            rows.shift();

            const createdOrders = rows.map(row => {
                const {cells} = row;
                const [
                    orderNumber,
                    receiverName,
                    receiverPhone,
                    receiverAddress,
                    receiverAddressDetail,
                    receiverLocationString,
                    productName,
                    amount,
                    ingredients,
                    index,
                    pickupInfoIndex
                ] = cells;

                if (!receiverLocationString?.value) {
                    receiverLocationString.value = "0,0";
                }
                const location = receiverLocationString.value.replace(/ /g, "").split(",");
                const receiverLocation = {
                    lat: parseFloat(location[0]),
                    lon: parseFloat(location[1])
                };

                return {
                    index: index?.value || null,
                    pickupInfoIndex: pickupInfoIndex?.value || null,
                    receiverName: receiverName.value,
                    receiverAddress: receiverAddress.value,
                    receiverAddressDetail: receiverAddressDetail?.value || "",
                    receiverPhone:
                        receiverPhone.value.toString().length === 10
                            ? `0${receiverPhone.value}`
                            : receiverPhone.value,
                    orderNumber: orderNumber.value.toString(),
                    receiverLocation,
                    products: [
                        {
                            productName: productName.value,
                            ingredients: ingredients.value,
                            amount: amount.value
                        }
                    ],
                    barcodeIsRequired: false
                };
            });
            message.success(
                t("newRequest.loadDeliveryPointsFromTemplateSuccess", {
                    ns: "newRequest",
                    orderNumber: createdOrders.length
                })
            );
            setForm(prevValues => ({
                ...prevValues,
                data: {...prevValues.data, orders: createdOrders}
            }));
        } catch (error) {
            message.error(t("Lütfen yüklemiş olduğunuz excel dosyasını kontrol ediniz."));
        }
    };

    const validateExcelData = data => {
        let isValid = true;
        return isValid;
    };

    const findCompany = async companyId => {
        const company = await stores.appStore.companyListFilter.find(cm => cm._id === companyId);
        return company;
    };

    const findSubCompany = async subCompanyId => {
        const subCompany = await stores.companyStore.subCompanyList.find(
            sc => sc._id === subCompanyId
        );
        return subCompany;
    };

    //#region pickupInfo
    const getToken = async ({apiKey, apiSecret}) => {
        try {
            const data = await stores.apiRequestStore.getAuthToken({apiKey, data: {apiSecret}});
            return data.token;
        } catch (err) {
            return null;
        }
    };

    const handleSelectCompany = async ({companyId}) => {
        const company = await findCompany(companyId);
        if (!company) return;
        const {apiKey, apiSecret} = company;
        const token = await getToken({apiKey, apiSecret});
        setSelectedCompany(company);
        setForm({...form, apiKey, token});
    };

    const fetchPaymentTypes = async (apiKey, token) => {
        if (!apiKey) return;

        setPaymentTypesLoading(true);
        try {
            const params = {
                apiKey,
                token
            };
            const result = await stores.codPaymentStore.paymentTypes(params);
            setPaymentTypes(result);
        } catch (error) {
            console.error("Error fetching payment types:", error);
            message.error("Ödeme tipleri yüklenirken bir hata oluştu");
        } finally {
            setPaymentTypesLoading(false);
        }
    };

    const handleSelectPickupPoint = async ({subCompanyId}) => {
        const subCompany = await findSubCompany(subCompanyId);
        if (!subCompany) return;
        setSelectedSubCompany(subCompany);

        //apiKey and token are not set yet
        const company = await findCompany(subCompany?.companyId);
        if (!company) return;
        const {apiKey, apiSecret} = company;
        const token = await getToken({apiKey, apiSecret});
        await fetchPaymentTypes(apiKey, token);
        const pickupInfos = form.data.pickupInfos.map(pickupInfo => {
            return {...pickupInfo, pickupPointId: subCompany?._id?.toString() || ""};
        });

        // alt firma değiştiğinde alıcı bilgilerini temizle
        const clearedOrders = form.data.orders.map(order => ({
            ...order,
            receiverName: "",
            receiverPhone: "",
            receiverAddress: "",
            receiverLocation: undefined,
            receiverAddressDetail: ""
        }));

        setForm({
            ...form,
            data: {
                ...form.data,
                pickupInfos,
                orders: clearedOrders
            },
            apiKey,
            token
        });

        const pickupInfoValidResponse = validatePickupInfo({_pickupInfo: pickupInfos});
        setErrors({...errors, ...pickupInfoValidResponse.errors});
    };
    //#endregion pickupInfo

    //#region order
    const createOrder = () => {
        const orders = form.data.orders;
        const newOrder = {
            ...orderPrototype,
            index: orders.length,
            orderNumber: generateRandomOrderNumber()
        };
        setForm({...form, data: {...form.data, orders: [...orders, newOrder]}});
    };
    const deleteOrder = ({orderIndex}) => {
        const orders = form.data.orders.filter((order, index) => index !== orderIndex);
        const updatedOrders = orders.map((order, index) => {
            return {...order, index: index};
        });
        const updatedForm = {...form, data: {...form.data, orders: updatedOrders}};
        setForm({...updatedForm});
        validateDelivery({_form: updatedForm});
    };
    const updateOrder = ({orderIndex, order}) => {
        const orders = form.data.orders;
        const updatedOrders = orders.map((ord, index) => {
            if (index === orderIndex) {
                // Merge the existing order with the new properties
                return {...ord, ...order};
            }
            return ord;
        });
        const updatedOrder = updatedOrders[orderIndex];
        setForm({...form, data: {...form.data, orders: updatedOrders}});
        const orderValidResponse = validateOrder({orderIndex, _order: updatedOrder});
        setErrors({...errors, ...orderValidResponse.errors});
    };
    //#endregion order

    //#region product
    const createProduct = ({orderIndex}) => {
        const orders = form?.data?.orders;
        const order = orders?.[orderIndex];
        const products = order?.products;
        const newProduct = {...productPrototype};
        const updatedProducts = [...products, newProduct];
        const updatedOrder = {...order, products: updatedProducts};
        const updatedOrders = orders?.map((ord, index) => {
            if (index === orderIndex) {
                return updatedOrder;
            }
            return ord;
        });
        setForm({...form, data: {...form.data, orders: updatedOrders}});
    };
    const deleteProduct = ({orderIndex, productIndex}) => {
        const orders = form?.data?.orders;
        const order = orders?.[orderIndex];
        const products = order?.products;
        const updatedProducts = products?.filter((prd, index) => index !== productIndex);
        const updatedOrder = {...order, products: updatedProducts};
        const updatedOrders = orders?.map((ord, index) => {
            if (index === orderIndex) {
                return updatedOrder;
            }
            return ord;
        });
        const updatedForm = {...form, data: {...form.data, orders: updatedOrders}};
        setForm({...updatedForm});
        validateDelivery({_form: updatedForm});
    };
    const updateProduct = async ({orderIndex, productIndex, product}) => {
        const orders = form?.data?.orders;
        const order = orders?.[orderIndex];
        const products = order?.products;
        const updatedProducts = products?.map((prd, index) => {
            if (index === productIndex) {
                return product;
            }
            return prd;
        });
        const updatedOrder = {...order, products: updatedProducts};
        const updatedOrders = orders?.map((ord, index) => {
            if (index === orderIndex) {
                return updatedOrder;
            }
            return ord;
        });

        setForm({...form, data: {...form.data, orders: updatedOrders}});

        const productValidResponse = validateProduct({orderIndex, productIndex, _product: product});
        setErrors({...errors, ...productValidResponse.errors});
    };
    //#endregion product

    //#region error
    const getError = key => {
        return errors?.[key] || null;
    };
    //#endregion error

    //validate form & if not valid set errors
    const validatePickupInfo = ({_pickupInfo = []}) => {
        let tempErrors = {};
        const pickupInfo = _pickupInfo.length !== 0 ? _pickupInfo : form?.data?.pickupInfos;
        const requiredMessage = t("validation.required", {ns: "common"});
        pickupInfo?.forEach((pI, index) => {
            if (!pI?.pickupPointId) {
                tempErrors[`pickupInfos.${index}.pickupPointId`] = requiredMessage;
            } else {
                tempErrors[`pickupInfos.${index}.pickupPointId`] = null;
            }
        });

        return {
            isValid: !Object.values(tempErrors).some(e => e),
            errors: tempErrors
        };
    };

    const validateProduct = ({orderIndex, productIndex, _product}) => {
        const key = `orders.${orderIndex}.products.${productIndex}`;
        const product = _product || form?.data?.orders?.[orderIndex]?.products?.[productIndex];
        const requiredMessage = t("validation.required", {ns: "common"});
        const _errors = [];
        if (!product?.productName) {
            _errors[`${key}.productName`] = requiredMessage;
        } else {
            _errors[`${key}.productName`] = null;
        }
        if (!product?.amount) {
            _errors[`${key}.productAmount`] = requiredMessage;
        } else {
            _errors[`${key}.productAmount`] = null;
        }
        return {
            isValid: !Object.values(_errors).some(e => e),
            errors: _errors
        };
    };
    const validateOrder = ({orderIndex, _order}) => {
        const key = `orders.${orderIndex}`;
        const order = _order || form?.data?.orders?.[orderIndex];
        const requiredMessage = t("validation.required", {ns: "common"});
        const isDedicatedIntegration =
            stores.meStore?.pool?.integrationType === "dedicatedIntegration";
        const _errors = [];
        if (!order?.receiverName) {
            _errors[`${key}.receiverName`] = requiredMessage;
        } else {
            _errors[`${key}.receiverName`] = null;
        }

        if (!isDedicatedIntegration) {
            if (!order?.receiverAddress) {
                _errors[`${key}.receiverAddress`] = requiredMessage;
            } else if (typeof order?.receiverLocation === "undefined") {
                _errors[`${key}.receiverAddress`] = requiredMessage;
            } else {
                _errors[`${key}.receiverAddress`] = null;
            }
        } else {
            _errors[`${key}.receiverAddress`] = null;
        }

        if (!isDedicatedIntegration) {
            const cleanPhone = order?.receiverPhone?.replace(/[-,(,),_\s]/g, "") || "";
            if (!order?.receiverPhone || cleanPhone.length === 0) {
                _errors[`${key}.receiverPhone`] = requiredMessage;
            } else if (cleanPhone.length !== 11) {
                _errors[`${key}.receiverPhone`] = "Telefon numarası 11 haneli olmalıdır";
            } else {
                _errors[`${key}.receiverPhone`] = null;
            }
        } else {
            _errors[`${key}.receiverPhone`] = null;
        }

        return {
            isValid: !Object.values(_errors).some(e => e),
            errors: _errors
        };
    };
    const validateDelivery = ({_form = form.data}) => {
        let tempErrors = {};
        //validate pickup point
        const pickupInfoValidResponse = validatePickupInfo({_pickupInfo: _form.pickupInfos});
        tempErrors = {...tempErrors, ...pickupInfoValidResponse.errors};

        _form?.orders?.forEach((order, index) => {
            const orderValidResponse = validateOrder({orderIndex: index, _order: order});
            tempErrors = {...tempErrors, ...orderValidResponse.errors};

            order?.products?.forEach((product, pIndex) => {
                const productValidResponse = validateProduct({
                    orderIndex: index,
                    productIndex: pIndex,
                    _product: product
                });
                tempErrors = {...tempErrors, ...productValidResponse.errors};
            });
        });

        setErrors({...tempErrors});

        return {
            isValid: !Object.values(tempErrors).some(e => e),
            errors: tempErrors
        };
    };

    const submitDeliveryRequest = async () => {
        const validationResult = validateDelivery({});
        if (!validationResult.isValid) return;

        //submit form
        const apiKey = form.apiKey;
        const token = form.token;
        const isDedicatedIntegration =
            stores.meStore?.pool?.integrationType === "dedicatedIntegration";

        const data = {
            ...form.data,
            orders: form.data.orders.map(order => ({
                ...order,
                index: order.index + 1,
                receiverPhone: order.receiverPhone
                    ? order.receiverPhone.replace(/[-,(,),_]/g, "")
                    : "",
                receiverLocation:
                    isDedicatedIntegration && !order.receiverAddress
                        ? {lon: 0, lat: 0}
                        : order.receiverLocation || {lon: 0, lat: 0}
            }))
        };
        const payload = {apiKey, token, data};

        const pricePromises = payload.data.orders.map(order =>
            stores.apiRequestStore
                .calculatePrice({
                    subCompanyId: selectedSubCompany?._id,
                    receiver: {
                        address: order.receiverAddress,
                        location: {
                            latitude: order.receiverLocation?.lat,
                            longitude: order.receiverLocation?.lon
                        }
                    },
                    apiKey,
                    token
                })
                .then(response => ({
                    ...response,
                    orderNumber: order.orderNumber
                }))
        );
        const userRole = stores.meStore.role || "user";
        const priceResponses = await Promise.all(pricePromises);
        const shouldSkipConfirmation =
            priceResponses.some(response => response?.data?.isWorkWithCredit === false) ||
            userRole === "admin";
        if (shouldSkipConfirmation) {
            const response = await stores.apiRequestStore.createDelivery(payload);
            if (response?.status === 200) {
                if (fromCustomerTheme) {
                    history.push("/musteri/siparislerim?orderType=current");
                } else {
                    history.push("/orders?orderType=current");
                }
            }
            return;
        }
        if (priceResponses.some(response => response?.status !== 200)) {
            return;
        }
        const orderDetails = priceResponses.map(priceResponse => ({
            orderNumber: priceResponse.orderNumber,
            distancePrice: priceResponse?.data?.detail?.distancePrice || 0,
            packagePrice: priceResponse?.data?.detail?.packagePrice || 0,
            distance: priceResponse?.data?.detail?.distance || 0,
            extraDistance: priceResponse?.data?.detail?.extraDistance || 0,
            totalPrice: priceResponse?.data?.price || 0
        }));

        const totalOrdersPrice = orderDetails.reduce((sum, order) => {
            return sum + (order.totalPrice || 0);
        }, 0);

        stores.appStore.openConfirmModal({
            title: "Sipariş Gönderimini Onaylıyor Musunuz?",
            width: "800px",
            content: (
                <>
                    <p>
                        Oluşturmakta olduğunuz{" "}
                        {orderDetails.length > 1 ? `${orderDetails.length} siparişe ` : `siparişe `}
                        ait ücret bilgileri aşağıdaki gibidir.
                    </p>
                    <Table
                        dataSource={orderDetails}
                        pagination={false}
                        rowKey={"orderNumber"}
                        summary={_ => (
                            <>
                                <Table.Summary.Row>
                                    <Table.Summary.Cell index={0} colSpan={5}>
                                        <b style={{fontSize: "18px", verticalAlign: "middle"}}>
                                            Toplam Ücret{" "}
                                            <i style={{fontSize: "12px", fontWeight: "normal"}}>
                                                (KDV dahildir)
                                            </i>{" "}
                                            :
                                        </b>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={1}>
                                        <b style={{fontSize: "18px"}}>
                                            {totalOrdersPrice.toFixed(2)} ₺
                                        </b>
                                    </Table.Summary.Cell>
                                </Table.Summary.Row>
                            </>
                        )}
                    >
                        <Table.Column title="Sipariş Numarası" dataIndex="orderNumber" />
                        <Table.Column
                            title="Mesafe"
                            dataIndex="distance"
                            render={distance => `${Number(distance).toFixed(2)} km`}
                        />
                        <Table.Column
                            title="Ekstra Mesafe"
                            dataIndex="extraDistance"
                            render={extraDistance => `${Number(extraDistance).toFixed(2)} km`}
                        />
                        <Table.Column
                            title="Mesafe Ücreti"
                            dataIndex="distancePrice"
                            render={distancePrice => `${Number(distancePrice).toFixed(2)} ₺`}
                        />
                        <Table.Column
                            title="Paket Ücreti"
                            dataIndex="packagePrice"
                            render={packagePrice => `${Number(packagePrice).toFixed(2)} ₺`}
                        />
                        <Table.Column
                            title="Toplam"
                            dataIndex="totalPrice"
                            render={totalPrice => `${Number(totalPrice).toFixed(2)} ₺`}
                        />
                    </Table>
                </>
            ),
            onOk: async () => {
                const response = await stores.apiRequestStore.createDelivery(payload);

                if (response?.status === 200) {
                    if (fromCustomerTheme) {
                        history.push("/musteri/siparislerim?orderType=current");
                    } else {
                        history.push("/orders?orderType=current");
                    }
                }
            },
            okText: "Evet",
            cancelText: "Hayır"
        });
    };

    const markerList = useMemo(() => {
        const pickupPoints = [selectedSubCompany]
            .filter(p => p?._id.toString())
            .map((pickupPoint, index) => {
                return {
                    index: index,
                    title: `${index + 1}`,
                    color: "red",
                    location: {
                        latitude: pickupPoint?.location?.latitude || 0,
                        longitude: pickupPoint?.location?.longitude || 0
                    }
                };
            });
        const deliveryPoints = form.data.orders
            .filter(order => order?.receiverLocation?.lat && order?.receiverLocation?.lon)
            .map((order, index) => {
                return {
                    index: index,
                    title: `${order.index + 2}`,
                    color: "gray",
                    location: {
                        latitude: order?.receiverLocation?.lat || 0,
                        longitude: order?.receiverLocation?.lon || 0
                    }
                };
            });

        return [...pickupPoints, ...deliveryPoints];
    }, [
        selectedSubCompany,
        JSON.stringify(form?.data?.orders?.map(order => order?.receiverLocation))
    ]);

    // Reverse geocoding function
    const reverseGeocode = async (lat, lng) => {
        try {
            const geocoder = new window.google.maps.Geocoder();

            return new Promise((resolve, reject) => {
                geocoder.geocode({location: {lat, lng}}, (results, status) => {
                    if (status === "OK" && results[0]) {
                        resolve(results[0].formatted_address);
                    } else {
                        reject(new Error("Geocoding failed"));
                    }
                });
            });
        } catch (error) {
            throw new Error("Geocoding service unavailable");
        }
    };

    // Handle map click - add pin to clicked location
    const handleMapClick = async ({lat, lng}) => {
        const orders = form.data.orders;

        if (orders.length === 0) {
            // If no orders exist, create a new one
            createOrder();

            // Wait a bit for the state to update, then update the new order
            setTimeout(async () => {
                try {
                    const address = await reverseGeocode(lat, lng);
                    updateOrder({
                        orderIndex: 0,
                        order: {
                            receiverLocation: {lat, lon: lng},
                            receiverAddress: address
                        }
                    });
                } catch (error) {
                    console.error("Reverse geocoding failed:", error);
                    updateOrder({
                        orderIndex: 0,
                        order: {
                            receiverLocation: {lat, lon: lng}
                        }
                    });
                }
            }, 100);
        } else {
            // Update the last order's location
            const lastOrderIndex = orders.length - 1;

            try {
                const address = await reverseGeocode(lat, lng);
                updateOrder({
                    orderIndex: lastOrderIndex,
                    order: {
                        receiverLocation: {lat, lon: lng},
                        receiverAddress: address
                    }
                });
            } catch (error) {
                console.error("Reverse geocoding failed:", error);
                updateOrder({
                    orderIndex: lastOrderIndex,
                    order: {
                        receiverLocation: {lat, lon: lng}
                    }
                });
            }
        }
    };

    return {
        createDeliveryRequestForm: form,
        selectedCompany,
        selectedSubCompany,
        handleExcelUpload,
        markerList,
        orderList: form.data.orders,
        handleSelectCompany,
        handleSelectPickupPoint,
        paymentTypes,
        paymentTypesLoading,

        /*----order----*/
        createOrder,
        updateOrder,
        deleteOrder,

        /*----product----*/
        createProduct,
        updateProduct,
        deleteProduct,

        /*----error----*/
        getError,

        /*----submit----*/
        submitDelivery: submitDeliveryRequest,

        /*----geocoding----*/
        reverseGeocode,
        handleMapClick
    };
};
